<script setup lang="ts">
import { useConfirmStore } from '@/shared/composable/useConfirm'
import ModalWindow from './ModalWindow.vue';
import ButtonElement from './form/base/ButtonElement.vue';

const store = useConfirmStore()
</script>

<template>
  <ModalWindow v-if="store.isOpen" @close-modal="store.cancel" modal-class="!max-w-120 !min-h-min">
    <div class="flex flex-col items-center pt-5 pb-6 text-center">
      <h3 class="mb-2 text-lg font-semibold text-gray-900 dark:text-gray-50">
        {{ store.header }}
      </h3>

      <p class="text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        {{ store.message }}
      </p>
    </div>

    <div class="flex items-center justify-center gap-3">
      <ButtonElement variant="compact" class="w-full" @click="store.cancel">
        {{ $t('common.no') }}
      </ButtonElement>
      <ButtonElement variant="primary" class="w-full" @click="store.confirm">
        {{ $t('common.yes') }}
      </ButtonElement>
    </div>
  </ModalWindow>
</template>
